import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/shared/utils';

type EntityReferenceItem = {
  id?: string;
  label: string;
  href?: string | null;
};

const normalizeLabel = (value: string | null | undefined): string => {
  const label = value?.trim();
  return label && label.length > 0 ? label : '-';
};

export function EntityReferenceValue({
  label,
  href,
  className,
  linkClassName,
}: {
  label: string | null | undefined;
  href?: string | null;
  className?: string;
  linkClassName?: string;
}) {
  const normalizedLabel = normalizeLabel(label);
  if (!href || normalizedLabel === '-') {
    return <span className={className}>{normalizedLabel}</span>;
  }

  return (
    <Link
      to={href}
      className={cn('text-primary hover:underline underline-offset-2', className, linkClassName)}
    >
      {normalizedLabel}
    </Link>
  );
}

export function EntityReferenceList({
  items,
  fallback = '-',
  className,
  linkClassName,
}: {
  items: EntityReferenceItem[];
  fallback?: string;
  className?: string;
  linkClassName?: string;
}) {
  if (items.length === 0) {
    return <span className={className}>{fallback}</span>;
  }

  return (
    <span className={className}>
      {items.map((item, index) => (
        <Fragment key={item.id || `${item.label}-${index}`}>
          {index > 0 ? ', ' : null}
          <EntityReferenceValue label={item.label} href={item.href} linkClassName={linkClassName} />
        </Fragment>
      ))}
    </span>
  );
}
